import React, { useRef, useEffect } from 'react';
type Props = {
  pspData: any;
};
export const FormAutoSubmit = ({ pspData }: Props) => {
  const formRef = useRef<Element | null | undefined>();
  useEffect(() => {
    // @ts-expect-error TODO(flow-migration) current is always defined, useEffect is trigger after mount ...
    formRef.current.submit();
  }, []);
  return (
    <form
      ref={formRef}
      id={pspData.id}
      className="ContactInfoRedirectForm"
      data-testid="PaymentProcess-FormAutoSubmit"
      method={pspData.method}
      action={pspData.url}
    >
      {Object.entries(pspData.fields).map(([fieldName, fieldValue]) => {
        return <input key={fieldName} type="hidden" name={fieldName} value={fieldValue} />;
      })}
    </form>
  );
};
